import {type TranslationObject} from '@colonist/i18n'
import {type RoomClientState} from '../../RoomClientState.ts'

export abstract class UIRoomWarningPopupContentBase {
    protected readonly roomState: RoomClientState

    constructor(roomState: RoomClientState) {
        this.roomState = roomState
    }

    abstract shouldShowWarning(): boolean
    abstract getTitle(): TranslationObject
    abstract getDescription(): TranslationObject
}
